module.exports = __webpack_public_path__ + "static/media/aspecto-de-la-literatura-min.9af6fcd3.png";